/**
 * Created by guoliangfang on 2017/8/22.
 */
import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import abortAjaxHoc from 'components/abortAjaxHoc';
import { Button,Input, Table} from 'antd';

import './style.less';
const Search = Input.Search;
const COMMON_COLUMNS = [
    {
        title: 'Sub-account',
        dataIndex: 'name',
        key: 'name',
        width: 100
    },
    {
        title: 'Real Name',
        dataIndex: 'real_name',
        key: 'real_name',
        width: 100
    },
    {
        title: 'Username',
        dataIndex: 'display_name',
        key: 'display_name',
        width: 100
    },
    {
        title: 'Roles and Permissions',
        dataIndex: 'role_and_permission',
        key: 'role_and_permission',
        width: 300
    },
    {
        title: 'Action',
        dataIndex: 'operation',
        key: 'operation',
        width: 100
    }
];

class  SubAccountManagement extends React.Component {
    constructor(props) {
        super(props);
        this.state={
            loading:true,
            account_hierarchy: null,
            columns: []
        };
        this.data = [];
        this.bizAccount = null;
    }

    async componentDidMount(){
        this.props.abortableAjax('GET','/auth/sub-accounts').then((res) => {
            const columns = JSON.parse(JSON.stringify(COMMON_COLUMNS));
            this.data = this.formatData(res.data, this.props.account_hierarchy);
            this.setState({
                data: this.data,
                loading:false,
                columns,
                account_hierarchy: this.props.account_hierarchy
            });
        });
    }

    pageTo(id){
        const { history } = this.props;
        if(!id){
            history.push('/pages/create-sub-account');
        }else{
            history.push(`/pages/edit-subaccount/${id}`);
        }
    }

    formatData(data){
        return data.map((item)=>{
            const roles = item.granted_roles.map((role)=>{
                return role.name;
            }).toString();
            item.role_and_permission = `${roles}  ${item.granted_permissions.length} permissions`;
            item.operation = <Button type="primary" onClick={this.pageTo.bind(this, item.id)}>Manage</Button>;
            return item;
        });
    }

    onSearch(value){
        const list = this.data;
        const newList = list.filter(item=>{
            return item.name.includes(value);
        });
        this.setState({ data: newList});
    }

    checkPerm = ()=>{
        const permissions = this.props.account_info.permissions;
        return !(permissions && permissions.includes('outer_manage_subaccount_full'));
    }



    render() {
        return (
            <div>
                <p className="sub-account-tips">You can create sub-accounts to manage the console with you. By configuring roles or permissions for them, you can restrict their data access and feature usage.<br/>
                    You can also delete these accounts at any time, and deleted accounts will no longer be able to use your console.</p>
                <p><Button type="primary" disabled={this.checkPerm()} onClick={this.pageTo.bind(this,null)}>Create Sub-account</Button></p>
                <p><Search
                    enterButton
                    placeholder="Search sub-account"
                    style={{ width: 200 }}
                    onSearch={this.onSearch.bind(this)}
                />
                </p>
                <div>
                    {Array.isArray(this.state.columns) && this.state.columns.length > 0 ?
                        <Table
                            rowKey='id'
                            columns={this.state.columns}
                            dataSource={this.state.data}
                            loading={this.state.loading}/> : null
                    }
                </div>

            </div>
        );
    }
}

SubAccountManagement.defaultProps = {};

// export default SubAccountManagement;

function select(state) {
    return {
        account_info: state.account.info,
    };
}

export default connect(select)(abortAjaxHoc(withRouter(SubAccountManagement)));



// WEBPACK FOOTER //
// ./src/pages/SubAccountManagement/index.js